import { CircleCheck } from "lucide-react";
import { STATUS_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

const FLOW = [
  { status: "Menunggu", text: "Pengaduan diterima dan menunggu ditinjau pengurus RT." },
  { status: "Dalam Proses", text: "Pengurus RT sedang menindaklanjuti laporan Anda." },
  { status: "Selesai", text: "Masalah telah ditangani dan pengaduan ditutup." },
];

const TIPS = [
  "Tuliskan lokasi spesifik (blok, nomor rumah, atau patokan).",
  "Lampirkan foto/video agar masalah mudah dipahami.",
  "Satu pengaduan untuk satu masalah agar penanganan lebih cepat.",
  "Simpan nomor tiket sebagai bukti pengaduan.",
];

export const InfoPanel = () => (
  <aside className="fade-up space-y-5 lg:sticky lg:top-32 lg:self-start" style={{ animationDelay: "220ms" }} data-testid="info-panel">
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="font-heading text-lg font-bold text-slate-900">Alur Tindak Lanjut</h3>
      <ol className="relative mt-5 space-y-5 before:absolute before:left-[11px] before:top-3 before:h-[calc(100%-1.5rem)] before:w-px before:bg-slate-200">
        {FLOW.map((f) => (
          <li key={f.status} className="relative flex gap-3">
            <span className={cn("relative z-10 mt-0.5 h-6 w-6 shrink-0 rounded-full border-[5px] border-white shadow ring-1 ring-slate-200", STATUS_STYLES[f.status].dot)} />
            <div>
              <p className="text-sm font-semibold text-slate-900">{f.status}</p>
              <p className="text-sm text-slate-500">{f.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
    <div className="relative overflow-hidden rounded-3xl bg-emerald-700 p-6 text-white">
      <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-emerald-500/40 blur-2xl" />
      <h3 className="relative font-heading text-lg font-bold">Tips Pengaduan</h3>
      <ul className="relative mt-4 space-y-3">
        {TIPS.map((tip) => (
          <li key={tip} className="flex gap-2.5 text-sm text-emerald-50">
            <CircleCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-300" /> {tip}
          </li>
        ))}
      </ul>
    </div>
  </aside>
);
